import { isEqual } from "lodash";

export function storeUseCase(data) {
	if (!Array.isArray(data)) {
		return;
	}

	const currentDataString = sessionStorage.getItem("useCases") || "null";
	const currentData = JSON.parse(currentDataString);

	const newData = data.map(item => ({
		id: item.id,
		name: item.name,
		description: item.description,
		status: item.status,
		agentStatus: item.agentStatus,
		isAgentEnabled: item.isAgentEnabled,
		enableETR: item.enableETR,
		etrIssuance: item.etrIssuance,
	}));

	if (!isEqual(currentData, newData)) {
		sessionStorage.setItem("useCases", JSON.stringify(newData));
	}
}


export function getUseCaseId(id) {
	const nullUseCase = {
		name: "Loading...",
		id: id,
		description: "Loading...",
		status: null,
		agentStatus: null,
		isAgentEnabled: false,
		enableETR: false,
		etrIssuance: {
			isEnabled: false,
			networkIDs: [],
		},
	};

	const data = sessionStorage.getItem("useCases");
	if (!data || !id) {
		return nullUseCase;
	}

	const parsedData = JSON.parse(data);
	const useCase = parsedData.find(item => item.id === id);

	return useCase || nullUseCase;
}
